import {lazy, Suspense} from "react";
import LoaderPage from "./pages/LoaderPage";

const AsyncMainPage = lazy(() => import("./pages/MainPage"));

function App() {
	return (
		<div>
			<Suspense fallback={<LoaderPage/>}>
				<AsyncMainPage/>
			</Suspense>
		</div>
	);
}

export default App;
